"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepFreeze = deepFreeze;
exports.isDeepFrozen = isDeepFrozen;
exports.clonePlainData = clonePlainData;
/** Freezes a tree of plain objects and arrays in place; functions are left as they are. */
function deepFreeze(value) {
    if (typeof value === "object" && value !== null) {
        Object.freeze(value);
        Object.values(value).forEach(deepFreeze);
    }
    return value;
}
/** Whether a tree of plain objects and arrays is frozen all the way down. */
function isDeepFrozen(value) {
    if (typeof value !== "object" || value === null) {
        return true;
    }
    return Object.isFrozen(value) && Object.values(value).every(isDeepFrozen);
}
/**
 * A deep copy of a tree of plain objects and arrays (structuredClone is not
 * everywhere the package runs: jest's jsdom environment lacks it). Throws a
 * TypeError on anything else: functions, class instances, Maps.
 */
function clonePlainData(value) {
    if (typeof value === "function") {
        throw new TypeError("not plain data: a function");
    }
    if (typeof value !== "object" || value === null) {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map(clonePlainData);
    }
    const proto = Object.getPrototypeOf(value);
    if (proto !== Object.prototype && proto !== null) {
        throw new TypeError(`not plain data: a ${proto?.constructor?.name ?? "non-plain object"}`);
    }
    return Object.fromEntries(Object.entries(value).map(([key, v]) => [key, clonePlainData(v)]));
}
